var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExcelLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1221_34282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45 6.65156L3.5 5.60156V13.36C3.5 13.7143 3.78723 14.0016 4.14155 14.0016H14.4085C14.7628 14.0016 15.05 13.7143 15.05 13.36V10.5016L9.45 6.65156Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45 0H4.14155C3.78723 0 3.5 0.28723 3.5 0.641548V3.5L9.45 7L12.6 8.05L15.05 7V3.5L9.45 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5H9.45V7H3.5V3.5Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.75845 2.79688H3.5V11.5469H7.75845C8.11229 11.5457 8.39885 11.2592 8.4 10.9053V3.43842C8.39885 3.08458 8.11229 2.79803 7.75845 2.79688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.40845 3.14844H3.5V11.8984H7.40845C7.76229 11.8973 8.04885 11.6107 8.05 11.2569V3.78999C8.04885 3.43615 7.76229 3.14959 7.40845 3.14844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.40845 3.14844H3.5V11.1984H7.40845C7.76229 11.1973 8.04885 10.9107 8.05 10.5569V3.78999C8.04885 3.43615 7.76229 3.14959 7.40845 3.14844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.05845 3.14844H3.5V11.1984H7.05845C7.41229 11.1973 7.69885 10.9107 7.7 10.5569V3.78999C7.69885 3.43615 7.41229 3.14959 7.05845 3.14844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.641548 3.14844H7.05845C7.41276 3.14844 7.69999 3.43567 7.69999 3.78999V10.2069C7.69999 10.5612 7.41276 10.8484 7.05845 10.8484H0.641548C0.28723 10.8484 0 10.5612 0 10.2069V3.78999C0 3.43567 0.28723 3.14844 0.641548 3.14844Z",
    fill: "url(#paint0_linear_1221_34282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98633 9.08502L3.33593 6.99377L2.09938 4.91406H3.09408L3.76888 6.24406C3.83118 6.37041 3.87388 6.46421 3.89698 6.52616H3.90573C3.95006 6.42536 3.99673 6.32748 4.04573 6.23251L4.76708 4.91477H5.68022L4.41217 6.98222L5.71243 9.08501H4.74083L3.96138 7.62517C3.92466 7.56305 3.89351 7.49781 3.86828 7.43022H3.85673C3.8339 7.49644 3.80361 7.55985 3.76643 7.61922L2.96388 9.08502H1.98633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4077 0H9.44922V3.5H15.0492V0.641548C15.0492 0.28723 14.762 0 14.4077 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 7H15.0492V10.5H9.44922V7Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1221_34282",
    x1: 1.33765,
    y1: 2.64714,
    x2: 6.36236,
    y2: 11.3497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1221_34282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.05,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcelLogo);
export default __webpack_public_path__ + "static/media/icon-excel-logo.1ddc5c8c2aee1878fd42fb948e62194f.svg";
export { ForwardRef as ReactComponent };